export default function routerPush(router, path) {
    console.log(router);
    if (router) {
      router.push(path);
      console.log(`Navigated to: ${path}`);
    } else {
      console.error("Router object not provided");
    }
  }